// Sentry names page loads by raw path, so /user/4417 and /user/9082 would be separate rows.
// Raw path is still on the span as url.path if you need one specific ID.
export const routeNameFromPath = (pathname) =>
  pathname.replace(/\/\d+(?=\/|$)/g, "/:id");
